export const getPadding = (isFirst: boolean, isLast: boolean) => {
    if (isFirst) {
        return '0 8 0 0';
    }

    if (isLast) {
        return '0 0 0 8';
    }

    return '0 8';
};

export const getTextAlign = (isFirst: boolean, isLast: boolean) => {
    if (isFirst) {
        return 'left';
    }

    if (isLast) {
        return 'right';
    }

    return 'center';
};
